export const EVENT_TRACKING_CATEGORIES = {
  LEAD_MANAGEMENT: 'LeadManagement',
  MULTI_FAMILY_LEAD_MANAGEMENT: 'MultiFamilyLeadManagement',
  LEAD_MANAGEMENT_PAGE: 'LeadManagementPage',
  SATELLITE: 'Satellite',
} as const;
